import { render, staticRenderFns } from "./PermissionInApp.vue?vue&type=template&id=4030113a&"
import script from "./PermissionInApp.vue?vue&type=script&lang=js&"
export * from "./PermissionInApp.vue?vue&type=script&lang=js&"
import style0 from "./PermissionInApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports